export default "__VITE_ASSET__CC8AjXSH__"